import SupportScreenConnector from './SupportScreenConnector';

export default SupportScreenConnector;
